/** @format */

import React, { Component } from 'react';
import { Menu, Input, Form } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import './ClientsToolbar.css';

@inject('ClientsStore')
@observer
class ClientsToolbar extends Component {
  render() {
    const { ClientsStore } = this.props;
    const advanceSearch = ClientsStore.clientsParams.advancedSearch.active;
    return (
      <Menu className="clients-toolbar" borderless size="tiny">
        <Menu.Menu position="right">
          <Menu.Item>
            <Form size="tiny">
              <Input
                className={advanceSearch ? 'search-input open' : 'search-input'}
                onChange={(e, input) => ClientsStore.searchClient(input.value)}
                value={ClientsStore.clientsParams.searchValue}
                icon="search"
                placeholder="Digita per ricerca veloce o premi invio per ricerca avanzata"
              ></Input>
            </Form>
          </Menu.Item>
          <Menu.Item onClick={() => ClientsStore.openAdvancedSearch()}>
            <small className={advanceSearch ? 'strong' : null}>
              ricerca avanzata
            </small>
          </Menu.Item>
          {/* <Menu.Item>
                        <Button size="tiny" onClick={() => this.props.history.push('/clients/new/')} color="green"><Icon name="plus"/>Aggiungi Cliente</Button>
                    </Menu.Item> */}
        </Menu.Menu>
      </Menu>
    );
  }
}

export default withRouter(ClientsToolbar);
